export class ExportCatalogoINModel {
    idProgetto: number
}
